var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSrkApartIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 26.25L7.125 22.25L2.625 21.25L3.0625 16.625L0 13.125L3.0625 9.625L2.625 5L7.125 4L9.5 0L13.75 1.8125L18 0L20.375 4L24.875 5L24.4375 9.625L27.5 13.125L24.4375 16.625L24.875 21.25L20.375 22.25L18 26.25L13.75 24.4375L9.5 26.25ZM10.5625 23.0625L13.75 21.6875L17 23.0625L18.75 20.0625L22.1875 19.25L21.875 15.75L24.1875 13.125L21.875 10.4375L22.1875 6.9375L18.75 6.1875L16.9375 3.1875L13.75 4.5625L10.5 3.1875L8.75 6.1875L5.3125 6.9375L5.625 10.4375L3.3125 13.125L5.625 15.75L5.3125 19.3125L8.75 20.0625L10.5625 23.0625ZM12.4375 17.5625L19.5 10.5L17.75 8.6875L12.4375 14L9.75 11.375L8 13.125L12.4375 17.5625Z",
    fill: "#1D3B5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrkApartIcon2);
export default __webpack_public_path__ + "static/media/srk-apart-icon2.926e822114a7c1f064d7817eedaedab2.svg";
export { ForwardRef as ReactComponent };